import EmployerBankAccountPage from './EmployerBankAccountPage';
export default EmployerBankAccountPage;